/** Id of the meal that stands in for the logs made outside any meal */
export const PSEUDO_MEAL_ID = '00000000-0000-0000-0000-000000000000';
